import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss', '../../pages/authentication/authentication.scss'],
})
export class PhoneInputComponent implements OnInit, OnDestroy {
  @Input() control!: AbstractControl;
  @Input() selectedCountry: CountryISO = CountryISO.Australia;
  @Output() phoneChange = new EventEmitter<string>();

  CountryIso = CountryISO;
  SearchCountryField = SearchCountryField;

  private readonly mobilePlaceholders: Partial<Record<CountryISO, string>> = {
    [CountryISO.Australia]: '04XX XXX XXX',
    [CountryISO.NewZealand]: '02X XXX XXXX',
  };

  mobilePlaceholder: string = this.mobilePlaceholders[CountryISO.Australia] ?? '';
  errorMessage: string = '';

  private sub?: Subscription;

  ngOnInit() {
    this.mobilePlaceholder = this.mobilePlaceholders[this.selectedCountry] ?? '';
    this.sub = this.control.valueChanges.subscribe(value => {
      const e164 = value?.e164Number ?? value?.internationalNumber ?? '';
      this.phoneChange.emit(e164);
      this.updateErrorMessage(e164);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onCountryChange(country: { iso2: string }) {
    this.mobilePlaceholder = this.mobilePlaceholders[country.iso2 as CountryISO] ?? '';
  }

  private updateErrorMessage(phoneNumber: string) {
    if (!phoneNumber) {
      this.errorMessage = 'Mobile number is required';
    } else if (this.control.invalid) {
      this.errorMessage = 'Mobile number is not valid';
    } else {
      this.errorMessage = '';
    }
  }
}
